import React from 'react';
import PropTypes from 'prop-types';
import { TilesComponent, IndvidualComponent } from './Tiles.styles.js';
import Tile from 'components/_common/tile/Tile.js';

const Tiles = ({ tiles, brand, langFolder, pageID }) => {

  return tiles?.length > 1 ? (
    <TilesComponent count={tiles.length}>
      {tiles.map((tile, index) => (
        <Tile key={`${tile.label}-${index}`} {...tile} brand={brand} langFolder={langFolder} pageID={pageID}></Tile>
      ))}
    </TilesComponent>
  ) : (
    <IndvidualComponent count={tiles.length}>
      {tiles?.map((tile, index) => (
        <Tile key={`${tile.label}-${index}`} {...tile} brand={brand} langFolder={langFolder} pageID={pageID}></Tile>
      ))}
    </IndvidualComponent>
  );
};

Tiles.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Tiles;
